import { Button } from 'antd';
import { useIntl } from 'react-intl';
import React, { Key } from 'react';
import { ButtonProps } from 'antd/es/button';

interface Props {
  danger?: boolean;
  onClick: () => void;
  intl: string;
  rules: boolean[];
  loading?: boolean;
  key?: Key;
}

const DirectSaleButtonsRules: React.FC<Props & ButtonProps> = ({
  danger,
  onClick,
  intl,
  rules,
  loading,
  key,
  ...props
}) => {
  const innerText = useIntl().formatMessage({ id: intl });

  if (rules.some((cur) => cur === true)) {
    return null;
  } else {
    return (
      <Button
        block
        {...(danger ? { danger: true } : { type: 'primary' })}
        onClick={onClick}
        key={key}
        loading={loading}
        {...props}
      >
        {innerText}
      </Button>
    );
  }
};

export default DirectSaleButtonsRules;
